// @flow
import './PublicBreadcrumb.css';

import * as React from 'react';
import classNames from 'classnames';
import StoreListener from '../store/StoreListener';
import { URLS, SELECTED_COLLECTION, SELECTED_ASSET } from '../store/Constants';
import { ZmCollection, RepoItem } from '../autogenerated/ZoomBridge';
import ViewUtil from '../ViewUtil';
import TextWithEllipsis from '../common/TextWithEllipsis';

type Props = {
  URLS: Object[],
  SELECTED_COLLECTION: ZmCollection,
  SELECTED_ASSET: RepoItem
};

type State = {};

const storeItems = [URLS, SELECTED_COLLECTION, SELECTED_ASSET];

@StoreListener(storeItems)
export default class PublicBreadcrumb extends React.Component<Props, State> {
  state = {};

  onCollectionClick = () => {
    ViewUtil.switchToAssetListView();
  };

  render() {
    const collection: ZmCollection = this.props[SELECTED_COLLECTION];
    const asset: RepoItem = this.props[SELECTED_ASSET];

    return (
      <div name="PublicBreadcrumb">
        {collection ? (
          <span
            className={classNames('collection', { active: !!asset })}
            style={{ fontSize: '22px', color: 'rgb(62, 62, 62)', fontWeight: '600' }}
            onClick={this.onCollectionClick}>
            {collection.getName()}
          </span>
        ) : null}
        {asset ? <span className="caret" style={{ backgroundImage: 'url(images/caret.svg)' }} /> : null}
        {asset ? (
          <span className="asset">
            <TextWithEllipsis
              text={asset.getName()}
              style={{ maxWidth: window.innerWidth / 2 - 25 }}
              textStyle={{}}
              responsive={false}
            />
          </span>
        ) : null}
      </div>
    );
  }
}
